import React from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { useTheme } from '../../../../components/mui/Styles/index'
import { Card, CardContent, Grid, Typography } from '../../../../components/mui/Core/index'

function ItemTagDetailsCard() {
  const theme = useTheme()
  const selectedInventoryItem = useSelector((state) => state.inventory.selectedInventoryItem)
  const selectedItemTag = useSelector((state) => state.serialNumbers.selectedItemTag)
  const expirationDate = selectedItemTag?.expirationDate

  const cardStyle = {
    height: '80%',
    borderRadius: '12px',
    border: `solid 1px ${theme.palette.common.white}`,
    backgroundColor: theme.palette.common.white,
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.16)',
    mb: '10px',
  }

  const cardContentStyle = {
    px: '24px',
  }

  const quantityStyle = {
    textAlign: 'right',
    mr: '32px',
  }

  return (
    <Card variant='outlined' sx={cardStyle}>
      <CardContent sx={cardContentStyle}>
        <Grid container spacing={1}>
          <Grid size={{ xs: 1.5 }}>
            <Typography variant='h6'>NDC/Item #</Typography>
          </Grid>
          <Grid size={{ xs: 3 }}>
            <Typography variant='h6'>Description</Typography>
          </Grid>
          <Grid size={{ xs: 1.2 }}>
            <Typography variant='h6'>Lot #</Typography>
          </Grid>
          <Grid size={{ xs: 0.5 }} sx={quantityStyle}>
            <Typography variant='h6'>Qty</Typography>
          </Grid>
          <Grid size={{ xs: 0.75 }}>
            <Typography variant='h6'>UOM</Typography>
          </Grid>
          <Grid size={{ xs: 1.4 }}>
            <Typography variant='h6'>Expiration</Typography>
          </Grid>
          <Grid size={{ xs: 1.3 }}>
            <Typography variant='h6'>Warehouse</Typography>
          </Grid>
          <Grid size={{ xs: 1 }}>
            <Typography variant='h6'>Location</Typography>
          </Grid>
          <Grid size={{ xs: 1 }}>
            <Typography variant='h6'>Item Code</Typography>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid size={{ xs: 1.5 }}>
            <Typography variant='body1'>{selectedInventoryItem?.itemNumber}</Typography>
          </Grid>
          <Grid size={{ xs: 3 }}>
            <Typography variant='body1'>{selectedInventoryItem?.itemDescription}</Typography>
          </Grid>
          <Grid size={{ xs: 1.2 }}>
            <Typography variant='body1'>{selectedItemTag?.lot}</Typography>
          </Grid>
          <Grid size={{ xs: 0.5 }} sx={quantityStyle}>
            <Typography variant='body1'>{selectedItemTag?.quantity}</Typography>
          </Grid>
          <Grid size={{ xs: 0.75 }}>
            <Typography variant='body1'>{selectedItemTag?.uom}</Typography>
          </Grid>
          <Grid size={{ xs: 1.4 }}>
            <Typography variant='body1'>
              {(expirationDate && moment.utc(expirationDate).format('L')) || 'None'}
            </Typography>
          </Grid>
          <Grid size={{ xs: 1.3 }}>
            <Typography variant='body1'>{selectedItemTag?.warehouse}</Typography>
          </Grid>
          <Grid size={{ xs: 1 }}>
            <Typography variant='body1'>{selectedItemTag?.location}</Typography>
          </Grid>
          <Grid size={{ xs: 1 }}>
            <Typography variant='body1'>{selectedItemTag?.itemCode}</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default ItemTagDetailsCard
